import {Flex, Image} from "antd";
import {Fade} from "react-awesome-reveal";
import img11 from "../../About/images/11.jpeg";
import MyText from "../../../components/UI/Text/MyText";
import {clrs} from "../../../constants/colors";
import HorizontalDivider from "../../../components/Divider/HorizontalDivider";
import {Link} from "react-router-dom";
import {LinkOutlined} from "@ant-design/icons";
import React from "react";

export const Person11 = () => {
    return (
        <Flex style={{ width: "100%", position: "relative" }} vertical gap={20}>
            <Flex style={{ width: "100%", position: "relative" }} gap={40}>
                <Fade triggerOnce={true} cascade damping={0.15}>
                    <Image src={img11} width={300} preview={false} style={{ borderRadius: 20 }} />
                </Fade>

                <Flex style={{ width: "100%", position: "relative" }} vertical>
                    <MyText strong size={"large"}>
                        Бақыткерейұлы Батырбек
                    </MyText>
                    <MyText style={{ color: clrs.whiterBlacker }}>
                        Bachelor of Informational Technologies, Master student of Computer Science and Engineering
                    </MyText>
                    <br />
                    <HorizontalDivider />
                    <br />
                    <Flex gap={20} wrap={"wrap"} vertical>
                        <Link target="_blank" to="https://orcid.org/0009-0008-6716-2457">
                            <MyText><LinkOutlined /> ORCID</MyText>
                        </Link>
                        <Link target="_blank" to="https://www.scopus.com/authid/detail.uri?authorId=59308762300">
                            <MyText><LinkOutlined /> Scopus</MyText>
                        </Link>
                    </Flex>
                    <br />
                    <MyText strong size={"small"}>Основное место работы, должность</MyText>
                    <MyText>
                        ТОО "Astana IT University", специалист департамента ЦКС<br />
                        <i>Стаж по профилю — 2 года</i>
                    </MyText>
                </Flex>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Роль в проекте или программе, а также характер выполняемой работы</MyText>
                <MyText size={"small"} italic>
                    Backend разработчик
                </MyText>
                <MyText size={"small"}>
                    - Совместное проведение экспериментальных исследований<br />
                    - Написание научных статей<br />
                    - Создание моделей облачной архитектуры программного комплекса, реализованного с использованием технологии микросервисов<br />
                    - Разработка методов передачи данных с первичных измерителей на основные стационарные источники эмиссий<br />
                    - Разработка интеллектуальной информационной системы: сбор и обработка неструктурированных данных из различных источников, сервисы визуализации и уровни доступа к данным, интерфейсы (API) для взаимодействия с внешними информационными системами
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Научные проекты, в которых принимал участие:</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Программа BR21882258: «Разработка комплекса интеллектуальных информационно-коммуникационных систем для экологического мониторинга эмиссий в окружающую среду для принятия управленческих решений в концепте углеродной нейтральности»<br />
                    - Программа BR24993128: «Разработка информационно-аналитической системы для принятия решений для эффективного использования трансграничных водных ресурсов в сельскохозяйственной отрасли Жамбылского региона»
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size="small">Публикации по теме проекта:</MyText>

                <MyText size="small" style={{ paddingLeft: 20 }}>
                    1. Toxanov S., Bakytkereiuly, B., A. Neftissov (2024). Development of a database for the main stationary sources of pollution with regulation of emissions quotas. 2024 IEEE International Conference on Smart Information Systems and Technologies (SIST)
                </MyText>

                <MyText size="small" style={{ paddingLeft: 20 }}>
                    2. Toxanov S., Sharipova S., Biloshchytskyi, A., Abzhanova D., Bakytkereiuly, B. (2024). Analysis of the impact of sharding on the scalability and efficiency of blockchain technologies for the creation of information-analytical systems for environmental monitoring of emissions into the environment. Scientific Journal of Astana IT University. 18, 66–74. https://doi.org/10.37943/18VIFS4010
                </MyText>
            </Flex>
        </Flex>
    );
}